/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Paper, Typography, Box } from '@mui/material';
import React from 'react';
import { useStyles } from './styles';
import { ADD_CLIENT_SECRET } from './constants';
import AddSecretDialog from '../../components/AddSecretDialog';
import { IAddSecretBoxProps } from '../../models/Machines/ClientContracts';
import { Key } from '@jda/lui-common-icon-library-mui5';

const AddSecretBox = ({
  refreshOnSave,
  displaySnackbar,
  hideSnackbar,
  machineId,
  maxExpiryDays,
  isModern,
  machineType,
}: IAddSecretBoxProps) => {
  const { classes } = useStyles();
  const [openModal, openCloseModal] = React.useState(false);
  return (
    <Paper variant="outlined" className={classes.addSecretPaper}>
      <Box className={classes.addSecretKeyBox} data-testid="add-secret-box" onClick={() => openCloseModal(!openModal)}>
        <Key fontSize="medium" />
        <Typography color="primary" className={classes.paddingStyler} data-testid="add-secret-label">
          {ADD_CLIENT_SECRET}
        </Typography>
      </Box>
      {openModal && (
        <AddSecretDialog
          openModal={openModal}
          openCloseModal={openCloseModal}
          refreshOnSave={refreshOnSave}
          displaySnackbar={displaySnackbar}
          hideSnackbar={hideSnackbar}
          machineId={machineId}
          maxExpiryDays={maxExpiryDays}
          isModern={isModern}
          machineType={machineType}
        />
      )}
    </Paper>
  );
};

export default AddSecretBox;
